import { TUrlParam } from "types/utils";

export enum EProfileQueryKeys {}

export const PROFILE_ENDPOINTS = {
  ROOT: "/profile",
  CHANGE_PHOTO: (userId: TUrlParam) => `/profile/${userId}/photo`,
};
